import React, { useRef } from "react";
import "./landing.css";

const LINES = [
  { id: 1, name: "Iceberg lettuce", image: "/images/1.png" },
  { id: 2, name: "Beetroot", image: "/images/2.png" },
  { id: 3, name: "Peaches", image: "/images/3.png" },
  { id: 4, name: "Potatoes", image: "/images/4.png" },
  { id: 5, name: "Strawberries", image: "/images/5.png" },
  { id: 6, name: "Parsley", image: "/images/6.png" },
];

export default function BestSelling() {
  const railRef = useRef(null);

  const nudge = (direction) => {
    const rail = railRef.current;
    if (!rail) return;
    const card = rail.querySelector(".tfm-rail__card");
    const step = card ? card.offsetWidth + 18 : rail.clientWidth * 0.8;
    rail.scrollBy({ left: step * direction, behavior: "smooth" });
  };

  return (
    <section className="tfm-section tfm-section--recessed" id="bestselling">
      <div className="tfm-container">
        <div className="tfm-rail__head">
          <div className="tfm-section-head">
            <p className="tfm-eyebrow">Popular lines</p>
            <h2 className="tfm-h2" style={{ marginTop: "1.1rem" }}>
              What kitchens order most.
            </h2>
            <p className="tfm-lede">
              A few of the lines that move fastest. The full catalogue, with the
              day&rsquo;s availability, lives in the app.
            </p>
          </div>

          <div className="tfm-rail__nav">
            <button
              type="button"
              className="tfm-rail__btn"
              aria-label="Show previous produce"
              onClick={() => nudge(-1)}
            >
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                <path
                  d="M19 12H5m6 6-6-6 6-6"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </button>
            <button
              type="button"
              className="tfm-rail__btn"
              aria-label="Show next produce"
              onClick={() => nudge(1)}
            >
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                <path
                  d="M5 12h14m-6 6 6-6-6-6"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </button>
          </div>
        </div>

        <ul className="tfm-rail" ref={railRef}>
          {LINES.map((line) => (
            <li className="tfm-rail__card" key={line.id}>
              <img src={line.image} alt={line.name} loading="lazy" />
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
